const focusableElementsSelector =
  'a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'

const useFocusTrap = () => {
  let focusableElements = [] as unknown as NodeList
  let firstFocusable: HTMLElement
  let lastFocusable: HTMLElement
  let beforeCloseFocusRef: HTMLElement
  let trapRef: any

  function keyHandler(e: KeyboardEvent) {
    findFocusable()
    const isTabPressed = e.key === 'Tab'

    if (!isTabPressed) return

    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        lastFocusable.focus()
        e.preventDefault()
      }
    } else {
      if (document.activeElement === lastFocusable) {
        firstFocusable.focus()
        e.preventDefault()
      }
    }
  }

  function findFocusable() {
    if (!trapRef.value) return false

    focusableElements = (trapRef.value as HTMLElement).querySelectorAll(focusableElementsSelector)
    firstFocusable = focusableElements[0] as HTMLElement
    lastFocusable = focusableElements[focusableElements.length - 1] as HTMLElement

    if (!firstFocusable && !lastFocusable) return false

    return true
  }

  function initFocusTrap(ref: any) {
    trapRef = ref

    beforeCloseFocusRef = document.activeElement as HTMLElement
    const res = findFocusable()

    if (!res) return

    document.addEventListener('keydown', keyHandler)
    firstFocusable.focus()
  }

  function clearFocusTrap() {
    document.removeEventListener('keydown', keyHandler)
    beforeCloseFocusRef ? beforeCloseFocusRef.focus() : null
  }

  return {
    initFocusTrap,
    clearFocusTrap,
  }
}

export default useFocusTrap
